var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var AxialPadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return this.data.componentFamily();
        },
        function(value) {
            return this.data.componentFamily(value);
        },
        [this.data.componentFamily]
    );

    this.pitchOverride = this.shadow("pitchOverride",
        function() {
            return this.data.pitchOverride();
        },
        function(value) {
            return this.data.pitchOverride(value);
        },
        [this.data.pitchOverride]
    ); 
};

lib_core.inherit(AxialPadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
AxialPadGeneratorInteractionModel.$class = 'AxialPadGeneratorInteractionModel';

module.exports = AxialPadGeneratorInteractionModel;


AxialPadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];
    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.type.AXIAL.family) {
        var c = cio_datamodel.IpcDataModel.PthComponentAttribute.type.AXIAL.family[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForDensityLevel = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ("producibilityLevel", "Producibility Level"), this.densityLevel, this.componentDensityList)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForOverridingPinPitch = function() {
    return [PackageGeneratorInspectorConfig.getCheckBox(this.LCLZ('overridePitch', 'Override Pin Pitch'), this.pitchOverride)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForPitch = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('e', this.LCLZ('pinPitch', 'Pin Pitch'), this.verticalPinPitch, this.userSettingsModel.distanceUnit, this.pitchOverride)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b', this.LCLZ('leadDiameter', 'Lead Diameter'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyDiameter', 'Body Diameter'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

AxialPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('axialNote',
        '* Pin pitch is automatically calculated based on the size of body, terminal and producibility level to make the footprint IPC compliant.\
        However you can provide custom value by overriding pin pitch to create non IPC compliant footprint.')));
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForOverridingPinPitch());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};